import { Check, X } from 'lucide-react';

import { SectionWrapper } from '../../components/SectionWrapper';
import { comparisonRows } from './kaiCoachContent';
import { KaiCoachSectionHead } from './KaiCoachSectionHead';

import styles from './KaiCoachWhySection.module.css';

export function KaiCoachWhySection() {
  return (
    <SectionWrapper
      aria-labelledby="kai-coach-why-title"
      background="soft"
      data-testid="kai-coach-section-why"
    >
      <KaiCoachSectionHead
        id="kai-coach-why-title"
        kicker="Why it exists"
        lead="Your students already have chatbots that will draft a thesis in seconds. Kai Coach gives them what those tools won’t: a coach that makes them do the thinking, inside your course."
        title={
          <>
            General-purpose AI will write the essay on request.{' '}
            <em>Kai Coach is designed never to.</em>
          </>
        }
      />
      <div className={styles.compare}>
        {/* The column headings, for sighted readers on wide screens; each cell
            names its side for everyone else. */}
        <div aria-hidden="true" className={styles.columns}>
          <span>General-purpose chatbot</span>
          <span>Kai Coach</span>
        </div>
        <ul className={styles.rows}>
          {comparisonRows.map((row) => (
            <li className={styles.row} key={row.coach}>
              <p className={styles.cell}>
                <span className={styles.side}>
                  General-purpose chatbot<span className={styles.srOnly}>:</span>
                </span>
                <X aria-hidden="true" className={styles.iconNo} size={18} />
                <span className={styles.text}>{row.chatbot}</span>
              </p>
              <p className={`${styles.cell} ${styles.coachCell}`}>
                <span className={styles.side}>
                  Kai Coach<span className={styles.srOnly}>:</span>
                </span>
                <Check aria-hidden="true" className={styles.iconYes} size={18} />
                <span className={styles.text}>{row.coach}</span>
              </p>
            </li>
          ))}
        </ul>
      </div>
    </SectionWrapper>
  );
}
